import { render, staticRenderFns } from "./Sleep.vue?vue&type=template&id=21795e8e&"
import script from "./Sleep.vue?vue&type=script&lang=js&"
export * from "./Sleep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports